// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import qs from 'query-string';
import { API_BASED_USAGE, API_PER_ORG_BASED_USAGE, ORG_BASED_USAGE } from '../constants/metrics';

export default ({
  sortOrder,
  sortBy,
  limit,
  stats,
  timerange,
  endDate,
  startDate,
  buckets,
  apiIds,
  appIds,
  orgIds,
  planType,
  usageType,
  size,
}) => {
  const paramsObj = {};

  if (sortOrder) {
    paramsObj.sortOrder = sortOrder;
  }

  if (sortBy) {
    paramsObj.sortBy = sortBy;
  }

  if (stats && stats.length) {
    paramsObj.stats = stats.join();
  }

  if (apiIds) {
    paramsObj.apiIds = apiIds;
  }

  if (appIds) {
    paramsObj.appIds = appIds;
  }

  if (orgIds) {
    paramsObj.orgIds = orgIds;
  }

  if (planType) {
    paramsObj.planType = planType;
  }

  if (limit && limit.length) {
    if (planType) {
      if (usageType === API_BASED_USAGE) {
        paramsObj.apiLimit = limit.join();
      } else if (usageType === ORG_BASED_USAGE) {
        paramsObj.orgLimit = limit.join();
      } else if (usageType === API_PER_ORG_BASED_USAGE) {
        paramsObj.apiPerOrgLimit = limit.join();
        paramsObj.apiIds = apiIds;
        paramsObj.orgIds = orgIds;
      }
    } else {
      paramsObj.limit = limit.join();
    }
  }

  if (timerange) {
    paramsObj.timerange = timerange;
    if (timerange === 'custom') {
      paramsObj.startDate = startDate;
      paramsObj.endDate = endDate;
    }
  }

  if (buckets && buckets.length) {
    paramsObj.buckets = buckets.join();
  }

  if(size) {
    paramsObj.size = size;
  }
  // use query-string for stringify
  const paramsString = qs.stringify(paramsObj, { encode: false });

  return paramsString === '' ? '' : `?${paramsString}`;
};

